export const URL_LIST = {
  LOGIN: "/usercenter/unauth/account/login",
  LOGIN_OUT: "/tenant/unauth/account/logout",
  GET_CUSTOMS_BY_SEARCH: "/cro/custom/getCustomsBySearch",
  WX_SIGN: "/cro/unauth/common/wxSign",
  UPLOAD_INVOICE: "/cro/invoice/uploadInvoice2",
  UPLOAD_IMGS: "/cro/invoice/uploadImgs2",
};



// WEBPACK FOOTER //
// ./src/config/url.js